import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { cn } from "../lib/utils";

export const HoverEffect = ({
  items,
  className
}) => {
  let [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    (<div
      className={cn("grid grid-cols-1 md:grid-cols-2  lg:grid-cols-3 pb-10", className)}>
      {items.map((item, idx) => (
        <a
          href={item.visible ? item?.link : '#'}
          key={item?.link}
          className="relative group  block p-2 h-full w-full"
          onMouseEnter={() => setHoveredIndex(idx)}
          onMouseLeave={() => setHoveredIndex(null)}>
          <AnimatePresence>
            {hoveredIndex === idx && (
              <motion.span
                className="absolute inset-0 h-full w-full bg-neutral-200 dark:bg-[#5c5c5c] block  rounded-3xl"
                layoutId="hoverBackground"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: 1,
                  transition: { duration: 0.15 },
                }}
                exit={{
                  opacity: 0,
                  transition: { duration: 0.15, delay: 0.2 },
                }} />
            )}
          </AnimatePresence>
          <Card  isNew={item.isNew} visible={item.visible}>
            <CardTitle>{item.title}</CardTitle>
            <CardDescription>{item.description}</CardDescription>
          </Card>
        </a>
      ))}
    </div>)
  );
};

export const Card = ({
  className,
  visible,
  isNew,
  children
}) => {
  return (
    (<div
      className={cn(
        `rounded-2xl h-full w-full p-4 overflow-hidden relative  ${visible ? 'bg-black' : 'bg-[#252525]'} border border-transparent dark:border-white/[0.2] group-hover:border-slate-700 relative z-20`,
        className
      )}>
      {!visible && (
        <div className="absolute top-0 right-0 bg-slate-500 text-neutral-300 px-2 text-sm rounded-bl-lg">Coming soon</div>
      )}
       {isNew && (
        <div className="absolute top-1 -right-8 bg-red-500 rotate-45 text-neutral-300 w-[100px] flex items-center justify-center py-1 text-sm">New</div>
      )}
      <div className="relative z-50">
        <div className="p-4">{children}</div>
      </div>
    </div>)
  );
};
export const CardTitle = ({
  className,
  children
}) => {
  return (
    (<h4 className={cn("text-zinc-100 font-bold tracking-wide mt-4", className)}>
      {children}
    </h4>)
  );
};
export const CardDescription = ({
  className,
  children
}) => {
  return (
    (<p
      className={cn("mt-8 text-zinc-400 tracking-wide leading-relaxed text-sm", className)}>
      {children}
    </p>)
  );
};
